export const safeRun = (fn: () => void) => {
  try {
    fn();
  } catch {
    // fail-open by design: telemetry must never break UX flow
  }
};

export const safeWarn = (message: string, error: unknown) => {
  safeRun(() => {
    // keep warning side effects isolated
    console.warn(message, error);
  });
};
